import React, { useEffect } from 'react';
import { Field, useForm } from 'react-final-form';
import PropTypes from 'prop-types';
import FieldLabelAndError from './FieldLabelAndError';
import { ErrorMessage } from './ErrorMessage';
import { requiredUtil } from '../utils';
import { BorderStyle } from './FormFieldsStyling';

const GenericTextAreaInputField = ({
    name,
    label,
    className,
    placeholder,
    disabled = false,
    required = false,
    clearOnUnmount = false,
    dataTestId,
}) => {
    const form = useForm();
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (clearOnUnmount) {
            return () => form.change(name);
        }
    }, [clearOnUnmount]);

    const inputcss =
        className ||
        `mt-1 mx-4 w-full px-2 h-16 ml-1 pt-2 block placeholder-gray-500 shadow-sm sm:text-sm rounded-md ${BorderStyle}`;
    return (
        <Field name={name} validate={required ? requiredUtil : undefined}>
            {({ input, meta }) => (
                <div className="mb-4">
                    <FieldLabelAndError label={label} required={required} />
                    <div className="w-full">
                        <textarea
                            {...input}
                            placeholder={placeholder}
                            className={inputcss}
                            disabled={disabled}
                            data-testid={dataTestId || name}
                        />
                        <ErrorMessage meta={meta} />
                    </div>
                </div>
            )}
        </Field>
    );
};

GenericTextAreaInputField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    className: PropTypes.func,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    clearOnUnmount: PropTypes.bool,
    dataTestId: PropTypes.string,
};

export default GenericTextAreaInputField;
